module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Отказ"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "basic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('f-image', {
    attrs: {
      "src-default": "/network/static/img/default_family.jpg"
    },
    model: {
      value: (_vm.family.avatar),
      callback: function($$v) {
        _vm.$set(_vm.family, "avatar", $$v)
      },
      expression: "family.avatar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_name')))]), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "family_name",
      "hide-name": "",
      "errors": _vm.errorBag.collect('family_name'),
      "cplaceholder": "(пример: Иван и Мария Иванови)"
    },
    model: {
      value: (_vm.family.name),
      callback: function($$v) {
        _vm.$set(_vm.family, "name", $$v)
      },
      expression: "family.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_people')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_parents')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6ex"
    }
  }, [_vm._v("Роля")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_interests')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_photo')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$config.lists.familyRoles), function(roleDescription, role) {
    return _c('tr', [_vm._l((_vm.usersByRole[role]), function(user) {
      return [_c('td', {
        staticClass: "vertical-middle"
      }, [_c('span', [_vm._v(_vm._s(roleDescription.text))])]), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle"
      }, [_c('f-input', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "name": "person_name",
          "hide-name": "",
          "errors": _vm.errorBag.collect('person_name', 'user.' + user.id),
          "cplaceholder": '(пример: ' + roleDescription.placeholder + ')',
          "data-vv-scope": 'user.' + user.id
        },
        model: {
          value: (user.name),
          callback: function($$v) {
            _vm.$set(user, "name", $$v)
          },
          expression: "user.name"
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle"
      }, [_c('f-input', {
        attrs: {
          "cplaceholder": "(разделени със запетая)"
        },
        model: {
          value: (user.interests),
          callback: function($$v) {
            _vm.$set(user, "interests", $$v)
          },
          expression: "user.interests"
        }
      })], 1), _vm._v(" "), _c('td', [_c('f-image', {
        attrs: {
          "src-default": "/network/static/img/default.jpg"
        },
        model: {
          value: (user.avatar),
          callback: function($$v) {
            _vm.$set(user, "avatar", $$v)
          },
          expression: "user.avatar"
        }
      })], 1)]
    }), _vm._v(" "), (_vm.usersByRole[role].length === 0) ? [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "5"
      }
    }, [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          _vm.addParent(role)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" " + _vm._s(roleDescription.text))])])] : _vm._e()], 2)
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_children')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6ex"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_sex')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_birth_year')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.usersByRole.child), function(child, key) {
    return _c('tr', [_c('td', {
      staticClass: "text-center vertical-middle"
    }, [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_name",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_name', 'user.' + child.id),
        "cplaceholder": "Име",
        "data-vv-scope": 'user.' + child.id
      },
      model: {
        value: (child.name),
        callback: function($$v) {
          _vm.$set(child, "name", $$v)
        },
        expression: "child.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_sex",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_sex', 'user.' + child.id),
        "values": _vm.$config.lists.childRoles,
        "data-vv-scope": 'user.' + child.id
      },
      model: {
        value: (child.role),
        callback: function($$v) {
          _vm.$set(child, "role", $$v)
        },
        expression: "child.role"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_birth_year",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_birth_year', 'user.' + child.id),
        "data-vv-scope": 'user.' + child.id
      },
      model: {
        value: (child.birthYear),
        callback: function($$v) {
          _vm.$set(child, "birthYear", $$v)
        },
        expression: "child.birthYear"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('button', {
      staticClass: "btn btn-small btn-danger btn-icon remove",
      on: {
        "click": function($event) {
          _vm.removeChild(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.addChild()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_location')))]), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "values": _vm.$config.lists.countries,
      "name": "family_country",
      "errors": _vm.errorBag.collect('family_country')
    },
    model: {
      value: (_vm.family.country),
      callback: function($$v) {
        _vm.$set(_vm.family, "country", $$v)
      },
      expression: "family.country"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "values": _vm.$config.lists.states,
      "name": "family_state",
      "errors": _vm.errorBag.collect('family_state')
    },
    model: {
      value: (_vm.family.state),
      callback: function($$v) {
        _vm.$set(_vm.family, "state", $$v)
      },
      expression: "family.state"
    }
  }), _vm._v(" "), _c('f-input', {
    attrs: {
      "name": "family_city",
      "cplaceholder": "(не е задължително)"
    },
    model: {
      value: (_vm.family.city),
      callback: function($$v) {
        _vm.$set(_vm.family, "city", $$v)
      },
      expression: "family.city"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_social')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.family_social_network')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.family_social_url')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.family.info.social), function(social, key) {
    return _c('tr', [_c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-select', {
      attrs: {
        "values": _vm.$config.lists.socialNetworks
      },
      model: {
        value: (social.name),
        callback: function($$v) {
          _vm.$set(social, "name", $$v)
        },
        expression: "social.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      attrs: {
        "cplaceholder": "URL адрес"
      },
      model: {
        value: (social.url),
        callback: function($$v) {
          _vm.$set(social, "url", $$v)
        },
        expression: "social.url"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('button', {
      staticClass: "btn btn-small btn-danger btn-icon remove",
      on: {
        "click": function($event) {
          _vm.removeSocial(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.addSocial()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])], 2)]), _vm._v(" "), _c('br')])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-textarea', {
    attrs: {
      "name": "family_about",
      "crows": 20
    },
    model: {
      value: (_vm.family.info.about),
      callback: function($$v) {
        _vm.$set(_vm.family.info, "about", $$v)
      },
      expression: "family.info.about"
    }
  }), _vm._v(" "), _c('f-textarea', {
    attrs: {
      "name": "family_interests",
      "crows": 3
    },
    model: {
      value: (_vm.family.info.interests),
      callback: function($$v) {
        _vm.$set(_vm.family.info, "interests", $$v)
      },
      expression: "family.info.interests"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "hs"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_experience')))]), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    attrs: {
      "name": "family_experience",
      "hide-name": "",
      "errors": _vm.errorBag.collect('family_experience'),
      "cplaceholder": "(пример: 1)"
    },
    model: {
      value: (_vm.family.info.hsExperience),
      callback: function($$v) {
        _vm.$set(_vm.family.info, "hsExperience", $$v)
      },
      expression: "family.info.hsExperience"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_methods')))]), _vm._v(" "), _c('p', [_vm._v("Моля, изберете методите за домашно образование, които използвате във вашето семейство.")]), _vm._v(" "), _vm._l((_vm.$config.lists.hsmethods), function(method, key) {
    return _c('div', {
      staticClass: "row hs_method"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.family.info.hsMethods),
        expression: "family.info.hsMethods"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.family.info.hsMethods) ? _vm._i(_vm.family.info.hsMethods, key) > -1 : (_vm.family.info.hsMethods)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.family.info.hsMethods,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.family.info.hsMethods = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.family.info.hsMethods = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.family.info, "hsMethods", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator",
      class: {
        'bg-success': _vm.family.info.hsMethods.indexOf(key) !== -1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_c('strong', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(method.name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(method.desc) + "\n\t\t\t\t\t\t\t")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "upimg"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-image', {
    attrs: {
      "src-default": "/network/static/img/default_family_photo.jpg",
      "width": 0,
      "height": 300,
      "avatar": false,
      "upload-endpoint": 'backend://family/' + _vm.family.id + '/photo'
    },
    model: {
      value: (_vm.family.photo),
      callback: function($$v) {
        _vm.$set(_vm.family, "photo", $$v)
      },
      expression: "family.photo"
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills md-pills",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#basic"
    }
  }, [_vm._v("Профил")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#about"
    }
  }, [_vm._v("За нас")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#hs"
    }
  }, [_vm._v("Домашно образование")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#upimg"
    }
  }, [_vm._v("Снимка")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-492058f3!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/family/FamilyProfileEdit.vue
// module id = 652
// module chunks = 1